import { useBreakpointRange } from '@optimus-web/core';
import BreakpointRange, { BreakpointEnumItem } from './breakpointRange';

export const isMobileOrSmallPhone = (breakpointRange?: BreakpointEnumItem) =>
    breakpointRange != null && [BreakpointRange.Phone, BreakpointRange.SmallPhone].includes(breakpointRange);

export const useIsMobileOrSmallPhone = () => {
    const breakpointRange = useBreakpointRange<BreakpointEnumItem>();
    return isMobileOrSmallPhone(breakpointRange);
};

export const isMobile = (breakpointRange?: BreakpointEnumItem) => BreakpointRange.Phone === breakpointRange;

export const isTablet = (breakpointRange?: BreakpointEnumItem) =>
    breakpointRange != null && BreakpointRange.Tablet === breakpointRange;

export const isMobileOrTablet = (breakpointRange?: BreakpointEnumItem) =>
    breakpointRange != null && [BreakpointRange.Phone, BreakpointRange.Tablet].includes(breakpointRange);

export const isDesktopOrLargeDesktop = (breakpointRange?: BreakpointEnumItem) =>
    breakpointRange != null && [BreakpointRange.Desktop, BreakpointRange.LargeDesktop].includes(breakpointRange);

export const unreliableIsMobileDevice = () =>
    typeof window.orientation !== 'undefined' || window.navigator.userAgent.includes('IEMobile');
